import mongoose from 'mongoose';
import schema, { ITripQuoteRequestDocument } from '../schemas/trip-quote-requests';

const TripQuoteRequest = (mongoose.models.TripQuoteRequest ||
  mongoose.model<ITripQuoteRequestDocument>('TripQuoteRequest', schema)) as mongoose.Model<
  ITripQuoteRequestDocument
>;

export default TripQuoteRequest;
